import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import style from './resetButton.css';

class ResetButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    return (
      <div className={style.buttonRow} >
        <div className={style.backButton} onClick={this.props.funcBack}>&lt;&lt; Back</div>
        <div className={style.resetButton} onClick={this.props.funcReset}>Reset</div>
      </div>
    );
  }
}

// This is totally optional, but forces react to check the prop types
// when running in debug
ResetButton.propTypes = {
  funcReset: PropTypes.func.isRequired,
  funcBack: PropTypes.func.isRequired,
};

function mapStateToProps(state, props) {
  return {};
}
function mapDispatchToProps(dispatch, props) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(ResetButton);



// WEBPACK FOOTER //
// ./src/components/resetButton.js